import React from 'react'
import { createPortal } from 'react-dom'
import { TransitionGroup } from 'react-transition-group'
import styled, { useTheme } from 'styled-components'
import { useMatchBreakpoints } from 'vvs-uikit'
import Toast from './Toast'
import { ToastContainerProps } from './types'

const StyledToastContainer = styled.div`
  .enter,
  .appear {
    opacity: 0.01;
  }

  .enter.enter-active,
  .appear.appear-active {
    opacity: 1;
    transition: opacity 250ms ease-in;
  }

  .exit {
    opacity: 1;
  }

  .exit.exit-active {
    opacity: 0.01;
    transition: opacity 250ms ease-out;
  }
`
const StyledTransitionGroup = styled(TransitionGroup)`
  display: flex;
  justify-content: center;
`

/**
 * Toast Container for only VVSgotchi toasts
 */
const GotchiToastContainer: React.FC<ToastContainerProps> = ({ toasts, onRemove, ttl = 4000, stackSpacing = 100 }) => {
  const { zIndices } = useTheme()
  const { isMobile } = useMatchBreakpoints()

  return (
    <StyledToastContainer>
      <StyledTransitionGroup>
        {toasts
          .filter((e) => e.isVvsGotchi)
          .map((toast, index) => {
            const zIndex = (zIndices.toast - index).toString()
            const top = isMobile ? 60 + index * stackSpacing : window.innerHeight / 2 - 320

            return (
              <Toast
                key={toast.id}
                toast={toast}
                onRemove={onRemove}
                ttl={ttl}
                style={{ bottom: `${top}px`, zIndex }}
              />
            )
          })}
      </StyledTransitionGroup>
    </StyledToastContainer>
  )
}

let toastPortal: HTMLDivElement
const GotchiToastsPortal: React.FC<ToastContainerProps> = (props) => {
  if (!toastPortal) {
    toastPortal = document.createElement('div')
    document.body.appendChild(toastPortal)
  }

  return createPortal(<GotchiToastContainer {...props} />, toastPortal)
}

export default GotchiToastsPortal
